import ArrowUpRightIcon from '@atlaskit/icon/core/arrow-up-right';
import * as React from 'react';

export function SvgArrowSlanted() {
  return <ArrowUpRightIcon label="" testId="ads-refreshed-icon" />;
}
